import Image from 'next/image';
import React from 'react';

type ObjectFit = 'contain' | 'cover' | 'fill' | 'none' | 'scale-down' | 'unset';

type Props = {
  src: string;
  alt: string;
  className: string;
  objectFitvalue?: ObjectFit;
  width?: any;
  height?: any;
  bgColor?: any;
};
export const ImageComponent = (props: Props) => {
  const { src, alt, className, objectFitvalue = 'cover' } = props;
  return (
    <Image
      src={src}
      width="400"
      height="280"
      alt={alt}
      style={{
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        objectFit: objectFitvalue || ('cover' as ObjectFit),
      }}
      sizes="300px"
      className={className}
    />
  );
};

export const RoundedImageComponent = (props: Props) => {
  const {
    src,
    alt,
    className,
    width = '420',
    height = '280',
    bgColor = 'white',
  } = props;

  return (
    <Image
      src={src}
      width={width}
      height={height}
      alt={alt}
      style={{
        borderRadius: '50%',
        backgroundColor: bgColor,
        objectFit: 'cover',
      }}
      sizes="300px"
      className={className}
    />
  );
};

export const SquaredImageComponent = (props: Props) => {
  const {
    src,
    alt,
    className,
    width = '420',
    height = '280',
    bgColor = 'transparent',
  } = props;

  return (
    <Image
      src={src}
      width={width}
      height={height}
      alt={alt}
      style={{
        borderRadius: '5px',
        backgroundColor: bgColor,
        objectFit: 'cover',
      }}
      sizes="300px"
      className={className}
    />
  );
};
